import api from "./api-service";

export const login = (user) => {
  return api().post("/auth/login", user);
};
